








import ForgotPasswordLink from '@spa/components/pages/auth/signup/shared/forgot-password/Link.vue'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component({
  components: {
    ForgotPasswordLink,
  },
})
export default class DefaultForgotPassword extends Vue {
}
